import { models } from '@ynomia/core';

/** Shown as the placeholder, so the example is never mistaken for a value. */
export const MAPPING_FILTER_EXAMPLE = '[{ "key": "Type Name", "value": "B00" }]';

const isValidRegExp = (value: string): boolean => {
  try {
    RegExp(value);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Filters must be a JSON array of rules, each with a non-empty key and a non-empty value that is
 * a valid regular expression, or blank. Matches what the mapping function accepts: anything else
 * fails there, after translation, where the user never sees why.
 */
export const areMappingFiltersValid = (raw: string): boolean => {
  if (!raw.trim()) return true;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return false;
    return parsed.every(rule => (
      !!rule
      && typeof rule === 'object'
      && typeof rule.key === 'string' && !!rule.key
      && typeof rule.value === 'string' && !!rule.value
      && isValidRegExp(rule.value)
    ));
  } catch (e) {
    return false;
  }
};

/**
 * The value to persist. Always a real array: an empty one means "no filtering", which is a value
 * rather than the absence of one.
 */
export const parseMappingFilters = (raw: string): Array<models.ModelMappingFilter> => {
  if (!raw.trim() || !areMappingFiltersValid(raw)) return [];
  return JSON.parse(raw) as Array<models.ModelMappingFilter>;
};
